export const Statuses = {
  WAITING_RESPONSE: 1,
  IN_PROGRESS: 2,
  CONFIRMED: 3,
  DECLINED: 4,
};
